import typeActions from 'redux/typeActions';
import CONSTANT from 'constant';
import { returnValue } from 'common';

const initialState = {
  // loading
  isGettingServices: false,
  isGettingService: false,
  isCreatingService: false,
  isUpdatingService: false,
  isDeletingService: false,
  // data
  services: {},
  service: {},
  // error
  errors: {
    getServices: '',
    getService: '',
    createService: '',
    updateService: '',
    deleteService: '',
  },
  // query
  search: '',
  page: 1,
  limit: 10,
  sort: 'createdAt:asc',
};

const serviceReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case typeActions.SET_SERVICE_VALUE:
      const { name, value } = actions;
      if (typeof name !== 'string') return { ...state };
      const obj = returnValue(state, name, value);

      return {
        ...state,
        ...obj,
      };

    case typeActions.GET_SERVICES_REQUEST:
      return {
        ...state,
        isGettingServices: true,
        errors: {
          ...state.errors,
          getServices: '',
        },
      };
    case typeActions.GET_SERVICES_SUCCESS:
      return {
        ...state,
        services: actions.data ?? {},
        isGettingServices: false,
        errors: {
          ...state.errors,
          getServices: '',
        },
      };
    case typeActions.GET_SERVICES_FAILED:
      return {
        ...state,
        services: {},
        isGettingServices: false,
        errors: {
          ...state.errors,
          getServices: actions.error,
        },
      };

    case typeActions.GET_SERVICE_REQUEST:
      return {
        ...state,
        isGettingService: true,
        errors: {
          ...state.errors,
          getService: '',
        },
      };
    case typeActions.GET_SERVICE_SUCCESS:
      return {
        ...state,
        service: actions.data || {},
        isGettingService: false,
        errors: {
          ...state.errors,
          getService: '',
        },
      };
    case typeActions.GET_SERVICE_FAILED:
      return {
        ...state,
        service: {},
        isGettingService: false,
        errors: {
          ...state.errors,
          getService: actions.error,
        },
      };

    case typeActions.CREATE_SERVICE_REQUEST:
      return {
        ...state,
        isCreatingService: true,
        errors: {
          ...state.errors,
          createService: '',
        },
      };
    case typeActions.CREATE_SERVICE_SUCCESS:
      return {
        ...state,
        isCreatingService: false,
        errors: {
          ...state.errors,
          createService: '',
        },
      };
    case typeActions.CREATE_SERVICE_FAILED:
      return {
        ...state,
        isCreatingService: false,
        errors: {
          ...state.errors,
          createService: actions.error,
        },
      };

    case typeActions.UPDATE_SERVICE_REQUEST:
      return {
        ...state,
        isUpdatingService: true,
        errors: {
          ...state.errors,
          updateService: '',
        },
      };
    case typeActions.UPDATE_SERVICE_SUCCESS:
      return {
        ...state,
        isUpdatingService: false,
        errors: {
          ...state.errors,
          updateService: '',
        },
      };
    case typeActions.UPDATE_SERVICE_FAILED:
      return {
        ...state,
        isUpdatingService: false,
        errors: {
          ...state.errors,
          updateService: actions.error,
        },
      };

    case typeActions.DELETE_SERVICE_REQUEST:
      return {
        ...state,
        isDeletingService: true,
        errors: {
          ...state.errors,
          deleteService: '',
        },
      };
    case typeActions.DELETE_SERVICE_SUCCESS:
      return {
        ...state,
        isDeletingService: false,
        errors: {
          ...state.errors,
          deleteService: '',
        },
      };
    case typeActions.DELETE_SERVICE_FAILED:
      return {
        ...state,
        isDeletingService: false,
        errors: {
          ...state.errors,
          deleteService: actions.error,
        },
      };

    case typeActions.GET_SERVICE_BY_REQUEST:
      return {
        ...state,
        isGettingService: true,
        errors: {
          ...state.errors,
          getService: '',
        },
      };
    case typeActions.GET_SERVICE_BY_SUCCESS:
      return {
        ...state,
        service: actions.data || {},
        isGettingService: false,
        errors: {
          ...state.errors,
          getService: '',
        },
      };
    case typeActions.GET_SERVICE_BY_FAILED:
      return {
        ...state,
        service: {},
        isGettingService: false,
        errors: {
          ...state.errors,
          getService: actions.error,
        },
      };
    default:
      return {
        ...state,
      };
  }
};
export default serviceReducer;
